'use strict';

import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { map } from 'lodash';

@connect()
export default class ContactDashboardSubNav extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    contactId: PropTypes.number
  };

  state = {
    currentRoute: '',
    routes: [
      {
        name: 'Profile',
        path: ''
      },
      {
        name: 'Company',
        path: 'company'
      }
    ]
  };

  handleClick = (destination) => {
    this.props.dispatch(push(`/admin/contacts/${this.props.contactId}/details/${destination}`));
    this.setState({currentRoute: destination});
  }

  render() {
    return (
      <ul className='contact-worksheet-subnav'>
        {map(this.state.routes, (route, index) =>
          <li
            key={index}
            data-id={`contact-path-${index}`}
            onClick={(e) => this.handleClick(route.path)}>
            <div className={route.path == this.state.currentRoute ? 'active' : ''}>{route.name}</div>
          </li>
        )}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/SubNav/index.js